import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getWmsOrdenByIdDocumento } from '../../api.wms';

const RecepcionEscanearOrden = () => {
  const [iddocumento, setIddocumento] = useState('');
  const [orden, setOrden] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleScan = async (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      if (!iddocumento.trim()) {
        setError('Por favor ingresa o escanea un ID de orden.');
        return;
      }
      // Normalizar: reemplazar comillas simples por guiones
      const iddocNormalizado = iddocumento.trim().replace(/'/g, '-');
      setLoading(true);
      setError('');
      setOrden(null);
      try {
        const data = await getWmsOrdenByIdDocumento(iddocNormalizado);
        if (data) {
          setOrden(data);
        } else {
          setError('No se encontró la orden de entrada con ese ID.');
        }
      } catch (err) {
        setError('Error al buscar la orden.');
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="max-w-lg mx-auto mt-12 p-6 bg-white rounded shadow border border-gray-200">
      <h2 className="text-xl font-bold mb-4 text-blue-900">Recepción de Pedido</h2>
      <label className="block mb-2 font-medium text-gray-700">Escanea la orden de entrega</label>
      <input
        type="text"
        value={iddocumento}
        onChange={e => setIddocumento(e.target.value)}
        onKeyDown={handleScan}
        placeholder="Escanea o ingresa el ID de la orden (ej. AMEI-...)"
        className="w-full border border-gray-300 rounded px-3 py-2 mb-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
        autoFocus
      />
      <button
        onClick={handleScan}
        className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded font-semibold mt-2"
        disabled={loading}
      >Buscar</button>
      {error && <div className="text-red-600 mt-2 font-medium">{error}</div>}
      {orden && (
        <div className="mt-6 border-t pt-4">
          <h3 className="font-semibold text-lg mb-2 text-blue-800">Orden encontrada</h3>
          <div className="mb-2 text-sm text-gray-700">ID Documento: <span className="font-mono">{orden.iddocumento}</span></div>
          <div className="mb-2 text-sm">Cliente: {orden.cliente_nombre || orden.cliente}</div>
          <div className="mb-2 text-sm">Almacén: {orden.almacen_nombre || orden.almacen}</div>
          <div className="mb-2 text-sm">Fecha: {orden.fecha}</div>
          <div className="mb-2 text-sm">Observaciones: {orden.observaciones || '-'}</div>
          <div className="mb-2 text-sm">Productos: {orden.productos?.length || 0}</div>
          <div className="flex gap-4 mt-4">
            <button
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded font-semibold"
              onClick={() => { setOrden(null); setIddocumento(''); }}
            >Cancelar</button>
            <button
              className="bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded font-semibold"
              onClick={() => navigate(`/wms/recepcion/flow/recepcion-pedidos?orden=${orden.iddocumento}`)}
            >Iniciar Recepción</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecepcionEscanearOrden;
